export default "__VITE_ASSET__CZbwOXvj__"